// import React, { Fragment } from 'react'
// const QuickSnapshot = ({snapShotData,image}) => {

//     return (
//         <div className={`p-5 md:pl-6 md:py-5 sm:m-10 ava-card-bg  rounded-xl`}>
//             <div className='md:px-5 flex md:flex-row flex-col  items-start justify-between gap-6 md:gap-3 '>
//                 {/* Left section */}
//                 <div className='flex flex-col items-start gap-3 max-w-xl md:pt-5'>
//                     <h2 className="ava-heading-md ">Quick Snapshot </h2>
//                     {snapShotData.map((item, index) => (
//                         <div key={index}
//                         //  className={` ${styles.snapshotText}`}
//                          >
//                             <span className='ava-text-subheading '>{item.label}:</span>{" "}
//                             <span className={`ava-text-body `}>{item.value}</span>
//                         </div>
//                     ))}
//                 </div>
//                 {/* Right section */}
//                 <div className="w-full md:w-[420px]">
//                     <div className="w-full h-[220px] md:h-[260px] lg:h-[260px]">
//                         <img
//                             // src="/Programs/gynacImage.jpg"
//                             src={image}
//                             alt="Program Gynac pic"
//                             className="w-full h-full object-cover rounded-xl"
//                         />
//                     </div>
//                 </div>
//             </div>
//         </div>
//     )
// }

// export default QuickSnapshot
import React from 'react';

/*
 * Reusable "What's Included" grid — works for every program.
 * Pass in the includedItems object straight from programDetails[PROGRAM_KEY].includedAndTracker.includedItems
 *
 * Expected shape:
 * {
 *   heading: string,
 *   description: string,
 *   cta: { label: string, href: string },
 *   items: [{ id, title, description, icon }]
 * }
 */
const WhatsIncluded = ({ data }) => {
  if (!data) return null;

  const { heading, description, cta, items = [] } = data;

  return (
    <section className="w-full py-8 md:py-10">
      <div className="container mx-auto px-4 md:px-10">

        {/* Header row */}
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4 mb-8">
          <div className="max-w-2xl">
            <h2 className="text-2xl md:text-[28px] font-bold text-[#1a1a2e] mb-2">
              {heading}
            </h2>
            {description && (
              <p className="text-sm text-[#6b7280] leading-relaxed">
                {description}
              </p>
            )}
          </div>

          {/* {cta?.label && (
            
            <a  href={cta.href || '#'}
              className="hidden md:flex items-center gap-1.5 text-sm font-semibold whitespace-nowrap"
              style={{ color: 'var(--primary-color)' }}
            >
              {cta.label}
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12h14" />
                <path d="M13 6l6 6-6 6" />
              </svg>
            </a>
          )} */}
        </div>

        {/* Cards grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {items.map((item) => (
            <IncludedCard key={item.id} item={item} />
          ))}
        </div>

        {/* CTA link on mobile — shown below the grid since the header row hides it there */}
        {cta?.label && (
          
           <a href={cta.href || '#'}
            className="flex md:hidden items-center gap-1.5 text-sm font-semibold mt-6 justify-center"
            style={{ color: 'var(--primary-color)' }}
          >
            {cta.label}
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M5 12h14" />
              <path d="M13 6l6 6-6 6" />
            </svg>
          </a>
        )}
      </div>
    </section>
  );
};

const IncludedCard = ({ item }) => {
  const { title, description, icon } = item;

  return (
    <div
      className="rounded-2xl bg-white p-5 md:p-6 border"
      style={{
        borderColor: 'var(--gray-200, #e5e7eb)',
        boxShadow: '0 2px 10px rgba(0,0,0,0.04)',
      }}
    >
      <div
        className="w-10 h-10 rounded-lg flex items-center justify-center mb-4"
        style={{ backgroundColor: 'var(--ava-color-primary-50, #EDE9FB)' }}
      >
        {icon && (
          <img src={icon} alt="" style={{ width: 20, height: 20 }} />
        )}
      </div>

      <h3 className="text-base font-bold text-[#1a1a2e] mb-1.5">
        {title}
      </h3>

      {description && (
        <p className="text-sm text-[#6b7280] leading-relaxed">
          {description}
        </p>
      )}
    </div>
  );
};

export default WhatsIncluded;